
import { COLLISION_CHECK_INTERVAL } from './constants.js'

function getRnd (max, min = 0) {
    // Compute the range of possible values, adding 1 to include the maximum value
    const range = max - min + 1;

    // Generate a random whole number within the range
    const randomNumber = Math.floor(random() * range) + min;

    // Return the random number
    return randomNumber;
}

function getRndNotRounded (max, min = 0) {
    // Compute the range of possible values, adding 1 to include the maximum value
    const range = max - min + 1;

    // Generate a random whole number within the range
    const randomNumber = random() * range + min;

    // Return the random number
    return randomNumber;
}

function getPolygonCoords (polygon, origin, zoom, angle) {
    let [ox, oy] = origin
    let coords = []
    for (let [x, y] of polygon) {
        const nx = ox + (x * zoom), ny = oy + (y * zoom)
        const [rx, ry] = rotateCoordinates([nx, ny], origin, angle)
        coords.push([rx, ry])
    }
    return coords
}

function gridCoordsToWorldCoords ([x, y], GRID_INTERVAL) {
    return [x * GRID_INTERVAL, y * GRID_INTERVAL]
}

function worldCoordsToGridCoords ([x, y], GRID_INTERVAL) {
    return [Math.floor(x / GRID_INTERVAL), Math.floor(y / GRID_INTERVAL)]
}

function rotateCoordinates(coords, origin, angle) {
    const radians = angle * Math.PI / 180; // convert degrees to radians
    const cosTheta = Math.cos(radians);
    const sinTheta = Math.sin(radians);

    const x = coords[0] - origin[0];
    const y = coords[1] - origin[1];
    const rotatedX = x * cosTheta - y * sinTheta;
    const rotatedY = x * sinTheta + y * cosTheta;
    return [rotatedX + origin[0], rotatedY + origin[1]];
}

function convert1DTo2D (i, GRID_SIZE) {
    const row = Math.floor(i / GRID_SIZE);
    const column = i % GRID_SIZE;
    return [column, row];
}

function convert2DTo1D (x, y, GRID_SIZE) {
    const index = y * GRID_SIZE + x;
    return index;
}

function lerpBetweenArrays(startArray, endArray, i) {
    const xDiff = (endArray[0] - startArray[0]) / (i + 1);
    const yDiff = (endArray[1] - startArray[1]) / (i + 1);
    const result = [];
    for (let j = 1; j <= i; j++) {
        result.push([Math.floor(startArray[0] + xDiff * j), Math.floor(startArray[1] + yDiff * j)]);
    }
    return result;
}

// check every point in the polygon to ensure they are the same color as the supplied base color
function checkPolygonCoords (p5, polygon, baseColor) {
    let collision = false
    const originColor = baseColor
    for (let i=1; i<polygon.length; i++) {
        // get intermediate points 
        const points = [
        polygon[i-1],
        ...lerpBetweenArrays(polygon[i-1], polygon[i], COLLISION_CHECK_INTERVAL),
        polygon[i]
        ]
        for (let [x, y] of points) {
        if (collision) break
        const rgb = getPixel(p5, x, y)
        collision = rgb !== originColor
        }
    }
    return !collision
}

// more effient than get() for interrogating pixel colour
function getPixel(p5, x, y) {
    x = Math.floor(x)
    y = Math.floor(y)
    const d = p5.pixelDensity();
    const i = 4 * d*(y * d*p5.width + x);
    const [r, g, b] = [p5.pixels[i], p5.pixels[i + 1], p5.pixels[i + 2]]; // get colors
    return `${r}-${g}-${b}`
}

function randomDistortion () {
    const neg = (random() > 0.5) ? -1 : 1
    return 1 + (getRnd(5, 1) * (0.01 * neg))
}

// run through coords [x,y] in polygon drawing line between
function drawPolygon (p5, polygon, origin, zoom, angle, fillColor, originColor) {
    try {
        p5.fill(fillColor)
    } catch (err) {
        console.log(err, fillColor)
    }
    const [ox, oy] = origin
    // close the shape
    polygon.push(polygon[0])
    let coords = getPolygonCoords (polygon, origin, zoom, angle, true)
    // now place dots along the length
    if (checkPolygonCoords(p5, coords, originColor)) {
        p5.beginShape()
        for (let [x, y] of coords) {
            p5.vertex(x, y)
        }
        p5.endShape()
        p5.loadPixels()
    }
}

  

export { getPixel, convert1DTo2D, convert2DTo1D, getRnd, getRndNotRounded, getPolygonCoords, gridCoordsToWorldCoords, worldCoordsToGridCoords, lerpBetweenArrays, rotateCoordinates, drawPolygon, randomDistortion }
